import { createSelector } from '@ngrx/store';
import { REQUEST_SEARCH_ALL_PENDING_INVITATIONS_ADMIN } from '../actions';
import * as actions from '../actions/index';
import { ORGANISATION_CONTEXT_SWITCH } from '../actions/meta.actions';
import { InvitationDto } from '@careapp-group/ng-sdk';

export interface State {
  loading: boolean;
  error: string;
  sent: boolean;
  entities: { [id: string]: InvitationDto };
  ids: Array<string>;
}

export const initialState: State = {
  loading: false,
  error: '',
  sent: false,
  entities: {},
  ids: [],
};

export function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case ORGANISATION_CONTEXT_SWITCH:
      return { ...state, entities: {}, ids: [] };
    case actions.REQUEST_INVITATION_SEND:
      return { ...state, loading: true, error: '' };
    case actions.RESPONSE_FAIL_INVITATION_SEND:
      return { ...state, loading: false, error: JSON.stringify((<any>action).payload) };
    case actions.RESPONSE_SUCCESS_INVITATION_SEND:
      return { ...state, loading: false, error: '', sent: true };
    case actions.REQUEST_INVITATION_RESET:
      return { ...state, error: '', sent: false };
    case actions.REQUEST_INVITATION_UPLOAD:
      return { ...state, error: '', loading: true };
    case actions.RESPONSE_SUCCESS_INVITATION_UPLOAD:
      return { ...state, error: '', loading: false, sent: true };
    case actions.RESPONSE_FAIL_INVITATION_UPLOAD:
      return {
        ...state,
        loading: false,
        sent: false,
        error: JSON.stringify((<any>action).payload),
      };
    case REQUEST_SEARCH_ALL_PENDING_INVITATIONS_ADMIN:
    case actions.REQUEST_INVITATIONS_PENDING:
      return { ...state, loading: true, error: '' };
    case actions.RESPONSE_SUCCESS_SEARCH_ALL_PENDING_INVITATIONS_ADMIN:
    case actions.RESPONSE_SUCCESS_INVITATIONS_PENDING:
      const ids = action.payload.map((org) => org.id);
      const entities = action.payload.reduce(
        (acc: any, entity: any) => ({ ...acc, [entity.id]: entity }),
        {}
      );
      return { ...state, loading: false, ids: ids, entities: entities };
    case actions.RESPONSE_FAIL_SEARCH_ALL_PENDING_INVITATIONS_ADMIN:
    case actions.RESPONSE_FAIL_INVITATIONS_PENDING:
      return {
        ...state,
        loading: false,
        sent: false,
        error: JSON.stringify((<any>action).payload),
      };

    case actions.RESPONSE_SUCCESS_INVITATION_RESEND:
      return {
        ...state,
        ids: Array.from(new Set([...state.ids, action.payload.id])),
        entities: { ...state.entities, [action.payload.id]: action.payload },
      };

    case actions.RESPONSE_SUCCESS_INVITATION_CANCEL:
      const newEntities = { ...state.entities };
      delete newEntities[action.payload.id];
      const newIds = state.ids.filter((id) => id !== action.payload.id);
      return {
        ...state,
        loading: false,
        entities: newEntities,
        ids: newIds,
      };

    case actions.RequestInviteWithToken.type:
      return { ...state, loading: true };
    case actions.SuccessInviteWithToken.type:
      return {
        ...state,
        loading: false,
        ids: Array.from(new Set([...state.ids, action.payload.id])),
        entities: { ...state.entities, [action.payload.id]: action.payload },
      };
    case actions.FailInviteWithToken.type:
      return {
        ...state,
        loading: false,
        error: (<any>action).error,
      };

    case actions.RequestAcceptInvite.type:
      return { ...state, loading: true };
    case actions.SuccessAcceptInvite.type:
      return { ...state, loading: false };
    case actions.FailAcceptInvite.type:
      return {
        ...state,
        loading: false,
        error: (<any>action).error,
      };

    default:
      return state;
  }
}

export const createSelectors = (rootReducer) => ({
  getError: createSelector(rootReducer, (state: State) => state.error),
  getLoading: createSelector(rootReducer, (state: State) => state.loading),
  getSent: createSelector(rootReducer, (state: State) => state.sent),
  getPending: createSelector(rootReducer, (state: State) =>
    state.ids.map((id) => state.entities[id])
  ),
});
